import { graphql } from 'gql/generated'

export const GET_VEHICLE_TEMPLATES_AUTOCOMPLETE = graphql(`
  query GetVehicleTemplatesAutocomplete($input: VehicleTemplateSuggestionsInput!) {
    vehicleTemplateSuggestions(input: $input) {
      total
      items {
        id
        name
        capacity
        type
      }
    }
  }
`)
